import { STEP_ID } from "@/components/constants";

/**
 * Steps never captured, whatever the hire consented to.
 *
 * Identity verification puts a government document on screen, so it is excluded by the step rather
 * than by the answer -- a grant cannot opt into it.
 */
export const NEVER_CAPTURED_STEP_IDS: readonly string[] = [
  STEP_ID.IDENTITY_CHECK,
];

export const isCaptureForbidden = (stepId: string): boolean =>
  NEVER_CAPTURED_STEP_IDS.includes(stepId);
